import React from 'react';
import {
  ContentTiles,
  ContentTilesProps,
  ContentTilesTile,
} from '@noths/polaris-client-ribbons-design-system';
import { getContentstackImageURL } from '@noths/polaris-client-utils';

import {
  ItemsTrackingContext,
  trackItemsImpression,
} from 'src/tracking/common/trackItemsImpression';
import { trackLinkClick } from 'src/tracking/common/trackLinkClick';
import { ContentTileSerializedTile } from '../../../content/sections/contentTiles/types';
import { setFeaturedProductParamOnURL } from '../../../utils/setFeaturedProductParamOnURL';
import { SectionContainer } from '../../molecules/SectionContainer/SectionContainer';
import * as styles from './ContentTilesSection.style';

export interface ContentTilesSectionProps extends Omit<ContentTilesProps, 'tiles'> {
  trackingTitle: string;
  trackingPosition?: number;
  tiles: ContentTileSerializedTile[];
}

export const ContentTilesSection = ({
  trackingPosition,
  trackingTitle,
  tiles,
}: ContentTilesSectionProps) => {
  const trackingContext: ItemsTrackingContext = {
    trackingPosition,
    trackingTitle,
    trackingContentType: 'Content tiles',
    numberOfItems: tiles.length,
  };

  return (
    <SectionContainer wrapperStyles={styles.wrapper} maxWidth="full" columnsXL={10}>
      <ContentTiles
        tiles={tiles.map(
          ({ imageSrc, ...tile }) =>
            ({
              ...tile,
              // @ts-ignore - Could not resolve this error: "Type error: Binding element 'width' implicitly has an 'any' type."
              imageSrc: ({ width, height, aspectRatio }) =>
                getContentstackImageURL(imageSrc, width, { aspectRatio, height }),
            } as ContentTilesTile),
        )}
        onVisible={() => tiles.length > 0 && trackItemsImpression(trackingContext)}
        onTileClick={(e, { index }) => {
          const tile = tiles[index];

          if (tile.featuredProductCode) {
            e.currentTarget.href = setFeaturedProductParamOnURL(
              e.currentTarget.href,
              tile.featuredProductCode,
            );
          }

          trackLinkClick(e, {
            ...trackingContext,
            link: { index, name: tile.title, href: e.currentTarget.href },
            actionName: 'Tile click',
          });
        }}
      />
    </SectionContainer>
  );
};

export type { ContentTilesProps };
